module.exports = __webpack_public_path__ + "static/media/icon-why-2.fc57655c.svg";